export default { 
  h070a5dc7ffbd095a09e32b5e0f9f2324: [[({}, []) => ["Face ID is a registered trademark of Apple. Inc."], {}]],
  h2cd2e0c024400be89cb48fe6b0fb783f: [[({}, [C0]) => [C0()], {}]],
  h37626aa8bcb39d0d37840e38c731a651: [[({}, []) => ["Cancel"], {}]],
  h3770fa7fa4d33000e5b58c5553073ce5: [[({}, [C0, C1]) => ["Simply check the Enable", " ", C0(), " Login checkbox on the Login page and follow the instructions. If you haven\u2019t already, you will also need to enable", " ", C1(), " ", "in your device\u2019s settings."], {}]],
  h3b7340af5bc49400bd536d9707e51479: [[({
  brand: brand
}, []) => ["You are about to enable Fingerprint Login for quick access to the ", brand.name, " mobile app as an alternative to your username and password."], {}]],
  h4e993b018a9779ecdbfff951ef0ffa36: [[({
  brand: brand
}, []) => ["Your ", brand.name, " Account is a Fingerprint Away"], {}]],
  hc9487bd4a9135984381b080d05b52ab0: [[({
  brand: brand
}, []) => ["You now have the option of using Face ID\xAE to log in to the", " ", brand.name, " mobile app! Once you enable this option, login will be much easier and faster!"], {}]],
  hcc05f97841a35897e7ffb13d89492a90: [[({
  brand: brand
}, []) => ["Enable Facial Recognition Login for Your ", brand.name, " Account."], {}]],
  hd2b3e266b9a50ddcdb532d8d35a138f6: [[({}, []) => ["REMEMBER: Anyone with a stored fingerprint on this device will have access to your Online Account."], {}]] 
}